module.exports = __webpack_public_path__ + "img/新闻中心.27ec357f.png";